import React from 'react';
import styles from '../LandingPage.module.css';

const StatsSection = () => {
  const stats = [
    { value: '50+', label: 'Enterprise GCC Programs' },
    { value: '10x', label: 'Faster Talent Onboarding' },
    { value: 'AI-First', label: 'Operating Model' },
    { value: '24/7', label: 'Delivery Governance' },
  ];

  return (
    <div className={styles.darkSection}>
      <div className={styles.section} style={{ paddingTop: '80px', paddingBottom: '80px' }}>
        <div className={styles.statsGrid}>
          {stats.map((stat, index) => (
            <div key={index} className={styles.statCard}>
              <div className={styles.statValue}>{stat.value}</div>
              <div className={styles.statLabel}>{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default StatsSection;
